
/**
 * @export
 * @enum {string}
 */
export enum SortField {
    TITLE = 'TITLE',
    TOPIC = 'TOPIC',
    START_DATE = 'START_DATE',
    END_DATE = 'END_DATE'
}